<template>
  <el-drawer title="审核企业" v-model="visible" :close-on-click-modal="false" destroy-on-close>
    <el-form label-width="100px" class="enterprise-approval-form" :model="auditInfo">
      <el-alert title="企业信息" type="info" :closable="false" />
      <el-form-item label="企业名称:">
        <el-input v-model="enterprise.fullName" disabled></el-input>
      </el-form-item>
      <el-form-item label="企业简称:">
        <el-input v-model="enterprise.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="LOGO:">
        <el-image v-if="enterprise.logoPath" style="width: 40px; height: 40px" :src="getFileUrl(enterprise.logoPath)"
          :preview-src-list="[getFileUrl(enterprise.logoPath)]" :initial-index="4" fit="cover">
        </el-image>
      </el-form-item>
      <el-form-item label="联系人:">
        <el-input v-model="enterprise.contactName" disabled></el-input>
      </el-form-item>
      <el-form-item label="联系电话:">
        <el-input v-model="enterprise.contactPhone" disabled></el-input>
      </el-form-item>
      <el-form-item label="统一信用代码:">
        <el-input v-model="enterprise.unifiedCreditCode" disabled></el-input>
      </el-form-item>
      <el-form-item label="经营范围:">
        <el-input type="textarea" v-model="enterprise.introduce" disabled></el-input>
      </el-form-item>
      <el-form-item label="营业执照:">
        <el-image v-if="enterprise.businessLicensePath" style="width: 200px; height: 200px" :src="getFileUrl(enterprise.businessLicensePath)"
          :preview-src-list="[getFileUrl(enterprise.businessLicensePath)]" :initial-index="4" fit="cover">
        </el-image>
      </el-form-item>
      <el-form-item label="申请人:">
        <el-input v-model="enterprise.registrationUserName" disabled></el-input>
      </el-form-item>
      <el-form-item label="申请时间:">
        <el-input v-model="enterprise.registrationTimeString" disabled></el-input>
      </el-form-item>
      
      <el-alert type="info" :closable="false">
        <template #title>
          管理设置
          <span style="color:red">(通过必填)</span>
        </template>
      </el-alert>
      <el-form-item label="是否长期有效:">
        <el-switch div v-model="auditInfo.isEffective" @change="isEffectiveChange"
          active-text="是" inactive-text="否" inline-prompt></el-switch>
      </el-form-item>
      <el-form-item label="有效开始日期:">
        <el-date-picker div type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
          v-model="auditInfo.effectiveStartDate"></el-date-picker>
      </el-form-item>
      <el-form-item label="有效结束日期:">
        <el-date-picker div type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
          v-model="auditInfo.effectiveEndDate"></el-date-picker>
      </el-form-item>

      <el-alert type="info" :closable="false">
        <template #title>
          审核意见
          <span style="color:red">(拒绝必填)</span>
        </template>
      </el-alert>
      <el-form-item label="审核意见:">
        <el-input type="textarea" div v-model="auditInfo.opinion" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="enterprise-approval-footer">
        <el-button type="primary" @click="save(1)" :loading="loading">通过</el-button>
        <el-button @click="save(2)" :loading="loading">驳回</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { enterpriseAudit } from '@/api/sys/org';
import { defineComponent } from 'vue'
import { getFileUrl } from '@/utils/common';

export default defineComponent({
  emits: ['update:modelValue', 'get-data'],
  data() {
    return {
      getFileUrl,
      auditInfo: {},
      loading: false
    }
  },
  props: {
    modelValue: Boolean,
    enterprise: Object
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    isEffectiveChange() {
      this.auditInfo.effectiveStartDate = '';
      this.auditInfo.effectiveEndDate = '';
    },
    save(auditStatus) {
      let auditInfo = this.auditInfo;
      if (auditStatus === 1 && !auditInfo.isEffective) {
        if (!auditInfo.effectiveStartDate) {
          this.$message.warning('请选择有效开始日期');
          return;
        }
        if (!auditInfo.effectiveEndDate) {
          this.$message.warning('请选择有效结束日期');
          return;
        }
        
        if (auditInfo.effectiveStartDate > auditInfo.effectiveEndDate) {
          this.$message.warning('有效结束日期不能小于开始日期');
          return;
        }
      }

      if (auditStatus === 2 && !auditInfo.opinion.trim()) {
        this.$message.warning('请填写审核意见');
        return;
      }

      auditInfo.auditStatus = auditStatus;
      auditInfo.id = this.enterprise.id;

      this.loading = true;
      enterpriseAudit(auditInfo).then(({data}) => {
        if (data.status) {
          this.$message.success(data.msg);
          this.visible = false;
          this.$emit('get-data')
        } else {
          this.$message.warning(data.msg);
        }
        this.loading = false;
      }).catch(_ => this.loading = false);
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.auditInfo = {
          isEffective: false,
          effectiveStartDate: '',
          effectiveEndDate: '',
          auditStatus: 0,
          opinion: ''
        }
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.enterprise-approval-form {
  padding: 0 20px;
  .el-alert {
    margin-bottom: 15px;
  }
}
.enterprise-approval-footer {
  width: 100%;
  text-align: center;
}

</style>